import { useAppSelector } from 'hooks/reduxHooks'

interface ItemState {
  isDeleted: boolean
  isSavedForLater: boolean
}

export function useUserCartItemState(itemId: string): ItemState {
  const itemState = useAppSelector(state => state.auth.userCart?.itemStates?.[itemId])

  return {
    isDeleted: itemState?.deleted ?? false,
    isSavedForLater: itemState?.saveForLater ?? false,
  }
}
